module.exports = (__webpack_require__(13))(4);


//////////////////
// WEBPACK FOOTER
// delegated ../static/lib/jquery/jquery-2.1.4.min.js from dll-reference vendors
// module id = 21
// module chunks = 23